// extracted by mini-css-extract-plugin
export default {"faqText":"FaqPage_faqText__ERQKZ"};